
import React from "react";
import { RecipeCategory, RecipeDifficulty } from "@/components/admin/tools/recipe-ideas/types";

interface RecipeFiltersProps {
  selectedCategory: RecipeCategory | 'All';
  setSelectedCategory: (category: RecipeCategory | 'All') => void;
  selectedDifficulty: RecipeDifficulty | 'All';
  setSelectedDifficulty: (difficulty: RecipeDifficulty | 'All') => void;
  kidFriendlyOnly: boolean;
  setKidFriendlyOnly: (value: boolean) => void;
  themeClasses: {
    buttonClass: string;
    activeButtonClass: string;
    inputClass: string;
  };
}

const RecipeFilters: React.FC<RecipeFiltersProps> = ({
  selectedCategory,
  setSelectedCategory,
  selectedDifficulty,
  setSelectedDifficulty,
  kidFriendlyOnly,
  setKidFriendlyOnly,
  themeClasses
}) => {
  const categories: (RecipeCategory | 'All')[] = [
    'All',
    'Holiday Cookies', 
    'Holiday Treats', 
    'Christmas Dinner', 
    'Breakfast', 
    'Snacks', 
    'Desserts', 
    'Drinks', 
    'Other'
  ];
  
  const difficulties: (RecipeDifficulty | 'All')[] = ['All', 'Easy', 'Medium', 'Hard'];
  
  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-lg font-medium mb-2">Category:</h3>
        <div className="flex flex-wrap gap-2">
          {categories.map((category) => (
            <button
              key={category}
              className={category === selectedCategory ? themeClasses.activeButtonClass : themeClasses.buttonClass}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>
      </div>
      
      <div>
        <h3 className="text-lg font-medium mb-2">Difficulty:</h3>
        <div className="flex flex-wrap gap-2">
          {difficulties.map((difficulty) => (
            <button
              key={difficulty}
              className={difficulty === selectedDifficulty ? themeClasses.activeButtonClass : themeClasses.buttonClass}
              onClick={() => setSelectedDifficulty(difficulty)}
            >
              {difficulty}
            </button>
          ))}
        </div>
      </div>
      
      <div className="flex items-center">
        <input
          type="checkbox"
          id="kidFriendly"
          checked={kidFriendlyOnly}
          onChange={(e) => setKidFriendlyOnly(e.target.checked)}
          className="mr-2 h-5 w-5"
        />
        <label htmlFor="kidFriendly" className="text-lg font-medium">
          Kid-friendly recipes only
        </label>
      </div>
    </div>
  );
};

export default RecipeFilters;
